import API from 'utils/api';
import { onError } from 'utils/handlers';

export const baseURI = 'catalogos/otro-tipo-de-nomina';

/**
 * GET Otros tipos de pagos de nómina
 * @returns {Promise<object[]>}
 */
export const getOtrosTiposDePagoNomina = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
    /* eslint-disable-next-line no-unreachable */
  } catch (err) {
    onError(err);
  }
  return [];
};
